import React, { useEffect } from 'react';
import { Stack, TextField, MenuItem, Button } from '@mui/material';
import { LocalizationProvider, DatePicker, DateTimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import PndRestApi from 'src/utils/pnd/PndRestApi';

const OrderReportFilters = ({
    hub,
    setHub,
    hubs,
    setHubs,
    rider,
    setRider,
    riders,
    setRiders,
    fromDate,
    setFromDate,
    toDate,
    setToDate,
    onSearch
}) => {
    useEffect(() => {
        const fetchHubs = async () => {
            const res = await PndRestApi.GetAllHubDetails();
            if (res?.status === 200) setHubs(res.data.data);
        };
        fetchHubs();
    }, [setHubs]);

    useEffect(() => {
        if (!hub) {
            setRiders([]);
            setRider('');
            return;
        }
        const fetchRiders = async () => {
            const res = await PndRestApi.getAllRiderDetailsByHubId(hub);
            if (res?.status === 200) setRiders(res.data.data);
        };
        fetchRiders();
    }, [hub, setRiders, setRider]);

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Stack direction="row" spacing={2} sx={{ mb: 2 }} alignItems="center">
                <TextField
                    select
                    label="Hub"
                    value={hub}
                    onChange={(e) => setHub(e.target.value)}
                    sx={{ minWidth: 180 }}
                >
                    <MenuItem value="">All</MenuItem>
                    {hubs?.map(h => (
                        <MenuItem key={h.hubId} value={h.hubId}>{h.hubName}</MenuItem>
                    ))}
                </TextField>

                <TextField
                    select
                    label="Rider"
                    value={rider}
                    onChange={(e) => setRider(e.target.value)}
                    sx={{ minWidth: 180 }}
                    disabled={!hub}
                >
                    <MenuItem value="">All</MenuItem>
                    {riders?.map(r => (
                        <MenuItem key={r.riderId} value={r.riderId}>{r.driverName}</MenuItem>
                    ))}
                </TextField>

                <DateTimePicker label="From Date" value={fromDate} onChange={setFromDate} />
                <DateTimePicker label="To Date" value={toDate} onChange={setToDate} />

                <Button variant="contained" color="primary" onClick={onSearch} sx={{ height: 40 }}>
                    Search
                </Button>
            </Stack>
        </LocalizationProvider>
    );
};

export default OrderReportFilters;
